export const STATE_HISTORY_KEY = 'RX.STATE';
